import React, { Component } from 'react';

import './App.css';
import MenuMaker from './MenuMaker/MenuMaker'
import {Editor} from './MenuMaker/MenuCustomCSS'
import Home from './Home'
import Dashboard from './Dashboard'
import {Link, Route, Switch} from 'react-router-dom'
import Devices from './Devices'
import Live from './Live'


class App extends Component {

  render() {

    return (
      <div>
        {/* <header className="App-header no-print">
          <span className="App-title">A Food Apart —— GridMenu </span>
        </header> */}
        {/* <header>Grid Menus by A Food Apart</header> */}

        <Switch>
          <Route path="/live" component={Live}></Route>
          <Route path="/_render/:shopId/:designId/:pageId" render={({match}) => {
            return(<MenuMaker shopId={match.params.shopId}
                              designId={match.params.designId}
                              pageId={match.params.pageId} />)
          }}></Route>

          <Route path="/_render_tv/:shopId/:tvId/:pageId" render={({match}) => {
            return(<MenuMaker tvId={match.params.tvId}
                              shopId={match.params.shopId}
                              pageId={match.params.pageId} />)
          }}></Route>



          <Route path="/devices" component={Devices}></Route>
          <Route path="/" exact component={Home}></Route>
          <Route path="/:shopId/css" render={(props) => {
            const shopId = props.match.params.shopId
            return(<Editor path={`css/${shopId}/global`}></Editor>)
          }}></Route>
          <Route path="/:shopId" render={(props) => {
            return(<Dashboard shopId={props.match.params.shopId} />)
          }} />

        </Switch>

        {/* <Route path="/:shopId/designs/:designId" render={(props) => {
          return(<MenuMaker
                    shopId={props.match.params.shopId}
                    designId={props.match.params.designId} />)
        }}></Route> */}
      </div>

    )
  }
}

export default App;
